import { createAppKit } from '@reown/appkit'
import { EthersAdapter } from '@reown/appkit-adapter-ethers'
import { bsc } from '@reown/appkit/networks'
import Web3 from 'web3';



window.addEventListener("load", async () => {
    if (window.ethereum) {
        try {
            // Check if MetaMask is already connected
            const accounts = await window.ethereum.request({ method: 'eth_accounts' });

            if (accounts.length > 0) {
                console.log("MetaMask is already connected:", accounts[0]);
            } else {
                console.log("MetaMask is installed but not connected. Waiting for user action.");
            }
        } catch (error) {
            console.error("Error checking MetaMask connection:", error);
        }
    } else {
        console.log("MetaMask is not installed.");
    }
});

 

// 1. Get projectId from https://cloud.reown.com
const projectId = '24179d901eaf864b1742ebab66388857';
let provider;
let web3;
let saleContract;
let account;
let chandiContract;

const rate = 0.00001; // 1 CHD = 0.00001 BNB

const saleABI = [
    {
        "inputs": [],
        "name": "buyTokens",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "fundsRaised",
        "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "saleStart",
        "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
        "stateMutability": "view",
        "type": "function"
    }
];

const chandiAddress = '0xEF0Fc160FcB37191a2cAdc1101eCB0001F70c3a8';

const chandiABI = [{ "inputs": [{ "internalType": "address", "name": "ownerWallet", "type": "address" }], "stateMutability": "nonpayable", "type": "constructor" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "allowance", "type": "uint256" }, { "internalType": "uint256", "name": "needed", "type": "uint256" }], "name": "ERC20InsufficientAllowance", "type": "error" }, { "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "uint256", "name": "balance", "type": "uint256" }, { "internalType": "uint256", "name": "needed", "type": "uint256" }], "name": "ERC20InsufficientBalance", "type": "error" }, { "inputs": [{ "internalType": "address", "name": "approver", "type": "address" }], "name": "ERC20InvalidApprover", "type": "error" }, { "inputs": [{ "internalType": "address", "name": "receiver", "type": "address" }], "name": "ERC20InvalidReceiver", "type": "error" }, { "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }], "name": "ERC20InvalidSender", "type": "error" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }], "name": "ERC20InvalidSpender", "type": "error" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }], "name": "OwnableInvalidOwner", "type": "error" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "OwnableUnauthorizedAccount", "type": "error" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "inputs": [], "name": "MAX_SUPPLY", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "documentLink", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "renounceOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "string", "name": "newLink", "type": "string" }], "name": "updateDocumentLink", "outputs": [], "stateMutability": "nonpayable", "type": "function" }];

const saleContractAddress = '0x820e99254dd377e6a19f20203d230f774e80a2a5';

// 2. Create your application's metadata object
const metadata = {
    name: 'Chandi',
    description: 'Chandi for sale',
    url: 'https://chandi.sarzone.com/', // origin must match your domain & subdomain
    icons: ['https://avatars.githubusercontent.com/u/179229932']
}

// 3. Create a AppKit instance
const modal = createAppKit({
    adapters: [new EthersAdapter()],
    networks: [bsc],
    metadata,
    projectId,
    features: {
        email: false, // default to true
        socials: [],
        emailShowWallets: false, // default to true
    }
})


async function handler() {
    try {
        const walletProvider = modal.getWalletProvider();
        provider = walletProvider;
        web3 = new Web3(walletProvider);

        // Get list of accounts from the connected wallet
        const accounts = await web3.eth.getAccounts();

        if (accounts.length === 0) {
            console.log("No account connected");
            return;
        }

        account = accounts[0]; // First connected account
        Array.from(document.getElementsByClassName("connect-wallet")).forEach((element) => {
            element.style.display = "none"; // Hide all elements with class 'connect-wallet'
        });

        document.querySelectorAll(".disconnect-wallet").forEach((disconnectBtn) => {
            disconnectBtn.style.display = "inline-block"; // Show Disconnect button
            // Update text and address
            const walletAddress = disconnectBtn.querySelector(".wallet-address");
            if (walletAddress && typeof account === "string") {
                walletAddress.innerText = `${account.slice(0, 6)}...${account.slice(-4)}`;
            }
        });


        saleContract = new web3.eth.Contract(saleABI, saleContractAddress);
        chandiContract = new web3.eth.Contract(chandiABI, chandiAddress);

        const balanceInWei = await saleContract.methods.fundsRaised().call();
        const balance = await chandiContract.methods.balanceOf(account).call();

        const conversion = BigInt(10 ** 18); // 1 CHD = 10^18 Wei
        const myBalance = BigInt(balance) / conversion;

        document.getElementById("myBalance").innerText = `${myBalance.toString()} CHD`;


        const inBnb = Number(balanceInWei) / Number(10 ** 18);
        document.getElementById("chandi-balance").innerText = `${inBnb}`;

        const totalChandiSold = Math.round(Number(inBnb) / 0.00001);
        const percentage = (totalChandiSold * 100) / 200000;

        // Update progress bar
        document.querySelector('.progress-bar').style.width = `${percentage}%`;
        document.querySelector('.progress').setAttribute('aria-valuenow', percentage);
        document.getElementById('soldChandi').innerText = `TOTAL CHD SOLD = ${totalChandiSold}`;

        // Handle wallet disconnect event
        provider.on('accountsChanged', (accounts) => {
            if (accounts.length === 0) {
                disconnectWallet();
            }
        });
    } catch (error) {
        console.error("Error connecting wallet:", error);
    }
}

modal.subscribeWalletInfo(handler);

document.querySelectorAll(".connect-wallet").forEach((element) => {
    element.addEventListener("click", (event) => {
        modal.open();
    });
});

document.getElementById("chandiAmount").addEventListener("input", (event) => {
    const bnbAmount = event.target.value;
});



document.getElementById("buyTokens").addEventListener("click", async (event) => {
    event.preventDefault(); // Prevent default behavior

    if (!provider) {
        return showErrorModal("Error", "Please connect your wallet first.");
    }

    const bnbAmount = document.getElementById("bnbAmount").value;
    if (!bnbAmount || parseFloat(bnbAmount) <= 0) {
        return showErrorModal("Error", "Please enter a valid BNB amount.");
    }

    try {
        const valueInWei = web3.utils.toWei(bnbAmount, "ether");

        // Estimate gas before sending the transaction
        const gasEstimate = await saleContract.methods.buyTokens().estimateGas({
            from: account,
            value: valueInWei
        });

        // Send transaction
        saleContract.methods.buyTokens().send({
            from: account,
            value: valueInWei,
            gas: gasEstimate
        })
        .on("transactionHash", (hash) => {
            console.log("Transaction sent, hash:", hash);
        })
        .on("receipt", (receipt) => {
            console.log("✅ Transaction confirmed:", receipt);
            showSuccessModal("Success", "Tokens purchased successfully!");
        })
        .on("error", (error) => handleTransactionError(error));

    } catch (error) {
        handleTransactionError(error);
    }
});

// ✅ Function to handle transaction errors and show correct messages
function handleTransactionError(error) {
    console.error("❌ Transaction failed:", error);

    let errorMessage = "Transaction failed. Please try again.";

    if (error?.message?.toLowerCase().includes("insufficient funds") ||
        error?.data?.message?.toLowerCase().includes("insufficient funds")) {
        errorMessage = "Insufficient BNB available. Please add funds to your wallet.";
    } else if (error?.code === -32000) {
        errorMessage = "Not enough gas or BNB balance.";
    } else if (error?.message?.toLowerCase().includes("user denied transaction")) {
        errorMessage = "Transaction was rejected by the user.";
    } else if (error?.message?.toLowerCase().includes("execution reverted")) {
        errorMessage = "Transaction failed due to contract execution error.";
    }

    showErrorModal("Error", errorMessage);
}

// ✅ Function to show modals (Success or Error) with Animation
function showModal(title, message, isSuccess) {
    const modalElement = document.getElementById("statusErrorsModal");
    if (!modalElement) return console.error("Modal element not found.");

    const modal = new bootstrap.Modal(modalElement, {
        backdrop: "static",
        keyboard: false,
    });

    const statusTitle = document.getElementById("statusTitle");
    const statusMessage = document.getElementById("statusMessage");
    const statusIcon = document.getElementById("statusIcon1");
    const closeButton = modalElement.querySelector(".btn-sm"); // ✅ Select button
    const modalButton = modalElement.querySelector("button"); // Get the button

    if (!statusTitle || !statusMessage || !statusIcon || !closeButton) {
        return console.error("One or more modal elements not found.");
    }

    // Set title & message text
    statusTitle.textContent = title;
    statusMessage.textContent = message;

    // Clear old icon
    statusIcon.innerHTML = "";

    // Define SVGs
    const successSVG = `
        <svg class="icon-animation" width="110" height="110" viewBox="0 0 50 50">
            <circle cx="25" cy="25" r="22" stroke="#198754" stroke-width="3" fill="none"/>
            <path d="M15 25 L22 32 L35 18" stroke="#198754" stroke-width="3" fill="none"/>
        </svg>`;

    const errorSVG = `
        <svg class="icon-animation" width="110" height="110" viewBox="0 0 50 50">
            <circle cx="25" cy="25" r="22" stroke="#db3646" stroke-width="3" fill="none"/>
            <line x1="15" y1="15" x2="35" y2="35" stroke="#db3646" stroke-width="3"/>
            <line x1="35" y1="15" x2="15" y2="35" stroke="#db3646" stroke-width="3"/>
        </svg>`;

    // Insert the correct SVG
    statusIcon.innerHTML = isSuccess ? successSVG : errorSVG;

    // ✅ Change button background and text dynamically
    if (isSuccess) {
        closeButton.classList.remove("errorBtn");
        closeButton.classList.add("successBtn");
        closeButton.textContent = "Ok";
        modalButton.onclick = function () {
            location.reload();
        };
    } else {
        closeButton.classList.remove("successBtn");
        closeButton.classList.add("errorBtn");
        closeButton.textContent = "Close";
    }

    // ✅ Reload page if success button is clicked
    closeButton.onclick = function () {
        if (isSuccess) {
            location.reload();
        }
    };

    // Show modal
    setTimeout(() => {
        modal.show();
    }, 100);

    // Apply animation to the icon after modal appears
    setTimeout(() => {
        const svgElement = statusIcon.querySelector(".icon-animation");
        if (svgElement) {
            svgElement.classList.add("animate-icon");
        }
    }, 300);
}


// ✅ Wrapper functions for clarity
function showSuccessModal(title, message) {
    showModal(title, message, true);
}

function showErrorModal(title, message) {
    showModal(title, message, false);
}






// Create a provider instance
const provider2 = new Web3.providers.HttpProvider('https://bsc-dataseed.binance.org/');

// Create a Web3 instance with the provider
const web = new Web3(provider2);
// Now you can access the eth object
const saleContract2 = new web.eth.Contract(saleABI, saleContractAddress);

// Now you can call contract methods that don't require a wallet connection
async function getContractDetails() {
    try {
        const balanceInWei = await saleContract2.methods.fundsRaised().call();

        const conversions = 1000000000000000000; // Convert to BigInt
        const inBnb = Number(balanceInWei) / Number(conversions);

        document.getElementById("chandi-balance").innerText = `${inBnb}`;
        const totalChandiSold = Math.round(Number(inBnb) / 0.00001);
        // const totalChandiSold = Number(inBnb) / 0.00001;
        const percentage = (totalChandiSold * 100) / 200000;
        // Update the progress bar
        document.querySelector('.progress-bar').style.width = `${percentage}%`;
        document.querySelector('.progress').setAttribute('aria-valuenow', percentage);
        document.getElementById('soldChandi').innerText = 'TOTAL CHD SOLD = ' + totalChandiSold;


        //  window.ethereum.on('disconnect', () => {
        //     console.log('Wallet disconnected');
        // });

    } catch (error) {
        console.error(error);
    }
}

document.addEventListener("DOMContentLoaded", async function () {
    await getContractDetails();
});




document.querySelectorAll(".disconnect-wallet").forEach((disconnectBtn) => {
    disconnectBtn.addEventListener("click", disconnectWallet);
    disconnectBtn.addEventListener("touchstart", disconnectWallet);
});

async function disconnectWallet(event) {
    event?.preventDefault(); // Prevent default behavior if event exists

    console.log("Disconnecting wallet...");

    try {
        await modal.disconnect();
        console.log("Wallet disconnected successfully.");
    } catch (error) {
        console.error("Error disconnecting wallet:", error);
    }

    // Reset all wallet-related data
    provider = undefined;
    web3     = undefined;
    account  = undefined;

    // Update UI after a short delay
    setTimeout(() => {
        document.querySelectorAll(".connect-wallet").forEach((element) => {
            element.style.display = "flex"; // Ensure it's visible
        });

        document.querySelectorAll(".disconnect-wallet").forEach((element) => {
            element.style.display = "none"; // Hide disconnect button
            element.innerHTML = `
                <span class="disconnect-text">Disconnect</span>
                <span class="wallet-address"></span>
            `;
        });

        document.getElementById("myBalance").innerText = `0 CHD`;
    }, 100);
}



